export default "__VITE_ASSET__DZOGwqPP__"